import React, { ReactNode } from 'react';
import classNames from 'classnames';

export interface NoteProps {
  icon?: ReactNode;
  body: ReactNode;
  classes?: string;
}

const Note = ({ icon, body, classes }: NoteProps) => {
  return (
    <div className={classNames('d-flex p-6 rounded-5 border gap-8', classes)}>
      {icon && <div>{icon}</div>}
      <div>{body}</div>
    </div>
  );
};

export default Note;
